export default {"src":"/_next/static/media/50-icon.c0a43657.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};